import { IChatImageFile } from '../../repositories/chats/entities/file/ChatImageFile';
import { TGetLatestChatFilesResponse } from '../../types/file';
import { ITypedReduxAction } from '../../types/redux/actionType';

export enum EChatImagesActionTypes {
  SetChatImagesPending = 'chat/images/getChatImagesPending',
  SetChatImagesSucceed = 'chat/images/getChatImagesSucceed',
  SetChatImagesFailed = 'chat/images/getChatImagesFailed',
  SetChatImagesEmpty = 'chat/images/setChatImagesEmpty',
  AddChatImages = 'chat/images/addChatImages',
}

export type TChatImagesPayload = {
  chatId: string;
};

export type TChatImagesSucceedPayload = {
  chatId: string;
} & TGetLatestChatFilesResponse;

export type TAddChatImagesPayload = {
  chatId: string;
  images: IChatImageFile[];
};

export type TChatImagesActions =
  | ITypedReduxAction<EChatImagesActionTypes.SetChatImagesPending, TChatImagesPayload>
  | ITypedReduxAction<EChatImagesActionTypes.SetChatImagesSucceed, TChatImagesSucceedPayload>
  | ITypedReduxAction<EChatImagesActionTypes.SetChatImagesEmpty, TChatImagesPayload>
  | ITypedReduxAction<EChatImagesActionTypes.SetChatImagesFailed, TChatImagesPayload>
  | ITypedReduxAction<EChatImagesActionTypes.AddChatImages, TAddChatImagesPayload>;
